var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showWarning
        ? _c("div", { staticClass: "bidding-watermark" }, [
            _c("div", [
              _vm._v(_vm._s(_vm.$t("YouAreCurrentlyOnBiddingInstance")))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    _vm.isOpen = true
                  }
                }
              },
              [_vm._v("x")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "790", width: "530", persistent: true },
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.executeMainAction.apply(null, arguments)
            }
          },
          model: {
            value: _vm.isOpen,
            callback: function($$v) {
              _vm.isOpen = $$v
            },
            expression: "isOpen"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "dialog-box" },
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("\n        " + _vm._s(_vm.$t("DismissFor")) + "\n      ")
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "secondary-button",
                      attrs: { ripple: false, text: "" },
                      on: { click: _vm.cancelDismiss }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.$t("Cancel")) + "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "main-button",
                      attrs: { ripple: false, text: "" },
                      on: {
                        click: function($event) {
                          return _vm.dismiss(0.25)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.$t("15min")) + "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "main-button",
                      attrs: { ripple: false, text: "" },
                      on: {
                        click: function($event) {
                          return _vm.dismiss(0.5)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.$t("30min")) + "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "main-button",
                      attrs: { ripple: false, text: "" },
                      on: {
                        click: function($event) {
                          return _vm.dismiss(1)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.$t("60min")) + "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-219770cd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-219770cd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Atoms/BiddingWarning.vue
// module id = null
// module chunks = 